




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Vehicle } from '../../models';
import { Method } from '../../utils';
import SearchVehicles from './SearchVehicles.vue';
import TextHighlight from 'vue-text-highlight';

@Component({
    components: { SearchVehicles, TextHighlight }
})
export default class SpotlightVehicles extends Vue {
    @Prop({ default: '' }) query: string;
    @Prop({ default: false }) isOpen: boolean;
    @Prop({ default: () => () => [] }) selectedVehicles: Vehicle[];
    @Prop({ default: () => () => console.log('[SpotlightVehicles] filter') }) filter: Method<string, void>;
    @Prop({ default: () => () => console.log('[SpotlightVehicles] showAndHide') }) showAndHide: Method<boolean, void>;

    get existVehicles(): boolean {
        return this.selectedVehicles.length > 0;
    }

    styleTextHighlight = {
        backgroundColor: '#4CAF50',
        color: 'white'
    };
}
